(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function isCountdownEnded(endDate) {
    return endDate.getTime() - Date.now() <= 0;
  }

  function switchToExpiredState(section) {
    var hero = section.querySelector('[data-votes-hero]');
    var timer = section.querySelector('[data-votes-timer]');
    var activeContent = section.querySelector('[data-content-set="active"]');
    var expiredContent = section.querySelector('[data-content-set="expired"]');

    section.classList.add('votes-landing--expired');

    if (timer) {
      timer.hidden = true;
    }

    var participants = document.querySelectorAll('.votes-participants');
    for (var p = 0; p < participants.length; p++) {
      participants[p].hidden = true;
    }

    if (section.getAttribute('data-has-expired-content') === 'true') {
      if (activeContent) activeContent.hidden = true;
      if (expiredContent) expiredContent.hidden = false;
    }

    if (!hero || hero.getAttribute('data-has-expired-banner') !== 'true') return;

    var activeBanner = hero.querySelector('[data-banner-set="active"]');
    var expiredBanner = hero.querySelector('[data-banner-set="expired"]');

    if (!activeBanner || !expiredBanner) return;

    activeBanner.hidden = true;
    expiredBanner.hidden = false;
    hero.classList.add('votes-landing__hero--expired');
  }

  function initExpiredState(section, endDate) {
    if (!isCountdownEnded(endDate)) return;
    switchToExpiredState(section);
  }

  function initCountdown(countdown) {
    var endDate = new Date(countdown.getAttribute('data-end'));
    if (isNaN(endDate.getTime())) return;

    var daysEl = countdown.querySelector('[data-countdown-days]');
    var hoursEl = countdown.querySelector('[data-countdown-hours]');
    var minutesEl = countdown.querySelector('[data-countdown-minutes]');
    var secondsEl = countdown.querySelector('[data-countdown-seconds]');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    var section = countdown.closest('.votes-landing');
    var expiredSwitched = section ? isCountdownEnded(endDate) : false;

    if (expiredSwitched && section) {
      switchToExpiredState(section);
    }

    function tick() {
      var diff = endDate.getTime() - Date.now();

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';

        if (!expiredSwitched && section) {
          switchToExpiredState(section);
          expiredSwitched = true;
        }
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  function boot() {
    var sections = document.querySelectorAll('.votes-landing');

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var hero = section.querySelector('[data-votes-hero]');
      var countdown = section.querySelector('[data-votes-countdown]');
      var endRaw = hero
        ? hero.getAttribute('data-countdown-end')
        : countdown
          ? countdown.getAttribute('data-end')
          : null;

      if (endRaw) {
        var endDate = new Date(endRaw);
        if (!isNaN(endDate.getTime())) {
          initExpiredState(section, endDate);
        }
      }

      if (countdown) {
        initCountdown(countdown);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
